import styled from 'styled-components';

export const StyledIconTextLinkRounded = styled.div`
  width: fit-content;

  .icon-text-link-rounded {
    display: flex;
    align-items: center;
    gap: 7px;
    text-transform: uppercase;
    cursor: pointer;
    text-decoration: none;
    color: inherit;

    &__text {
      p {
        transition: all 0.4s ease-in-out;
      }
    }

    &:hover > div:first-child {
      color: ${({ theme }) => theme.colors.white};
      background: ${({ theme }) => theme.colors.mainOrange};
    }

    &:hover .icon-text-link-rounded__text p {
      color: ${({ theme }) => theme.colors.mainOrange};
    }
  }
`;
